import styled from 'styled-components'
import Masonry from 'react-masonry-css'

export const MasonryWrapper = styled(Masonry)`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 20px 100px;

    @media (max-width: 1200px) {
        padding: 0 0;
    }
`

export const KioskWrapper = styled.div`
    position: relative;
    background-color: ${props => props.theme.kiosk_background || '#eff1f1'};
    margin: 8px;
    padding-top: 2px;
    border-radius: 3px;
    box-shadow: 0 1px 6px rgba(21, 24, 88, 0.05);
    transition: box-shadow 0.5s ease-in-out, -webkit-box-shadow 0.5s ease-in-out;
    border: 1px solid #d5d5d5;
    zoom: ${props => props.zoom}; /* 1.5 */
`
